import { getResourceStore } from "./crudFactory";
import { DUTY_ROLE } from "../constants/workResources";

/**
 * 資產的「管理者」＝ 負責關係（ticket 35）。
 *
 * 資產本身不存管理者,讀取時才從關係算出來(`decorate`),
 * 寫入時把 managerId 轉成關係(`syncManager`)。兩個方向都只碰同一份資料,
 * 所以不會出現「資產頁說是甲、工作項目頁說是乙」。
 */

const users = () => {
  const store = getResourceStore("user");
  return store ? store.all() : [];
};

const relations = () => getResourceStore("work-item");

const userById = (id) => users().find((u) => String(u.id) === String(id)) || null;

const findRelation = (resource, recordId) => {
  const store = relations();
  if (!store) return null;
  return (
    store
      .all()
      .find(
        (r) =>
          r.resource === resource &&
          String(r.recordId) === String(recordId) &&
          r.dutyRole === DUTY_ROLE.MANAGE
      ) || null
  );
};

/** 顯示用的「姓名（單位）」—— 各頁面原本就是這個樣子 */
const displayName = (user) => `${user.name}（${user.department || user.account}）`;

/** 讀取時補上 managerId / manager,兩者都不進 store */
export const decorateManager = (resource) => (row) => {
  const relation = findRelation(resource, row.id);
  const user = relation ? userById(relation.userId) : null;
  return {
    ...row,
    managerId: user ? user.id : null,
    manager: user ? displayName(user) : null,
  };
};

/**
 * 寫入時把 managerId 落成負責關係。
 * 回傳字串代表擋下這次寫入(crudFactory 會轉成 400)。
 * payload 沒有 managerId 就什麼都不做 —— 局部更新不該把管理者洗掉。
 */
export const syncManager = (resource) => (record, payload) => {
  if (!Object.prototype.hasOwnProperty.call(payload, "managerId")) return null;

  const store = relations();
  if (!store) return null; // 關係還沒註冊(理論上不會發生),不要半套寫入
  const existing = findRelation(resource, record.id);
  const raw = payload.managerId;

  // 管理者不再留在資產資料上,真相只有關係那一份
  delete record.managerId;
  delete record.manager;

  if (raw === null || raw === undefined || raw === "") {
    if (existing) store.remove(existing.id);
    return null;
  }

  const user = userById(raw);
  if (!user) return "查無指定的管理者，請重新選擇。";

  if (existing) {
    store.patch(existing.id, { userId: user.id });
  } else {
    store.add({
      userId: user.id,
      resource,
      recordId: record.id,
      dutyRole: DUTY_ROLE.MANAGE,
      transfer: null,
    });
  }
  return null;
};
